<div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
  <div class="row" infinite-scroll infiniteScrollDistance="1" infiniteScrollThrottle="300" (scrolled)="expand()">
    <div class="col-sm-12 col-md-12">

      <h1>{{ 'header.orders' | translate }}</h1>

      <p class="subheader">
        <strong>{{ 'orders.subheader' | translate }} </strong><br/>
        {{ 'orders.subheader-second' | translate }}
      </p>

      <ng-container *ngIf="!loading">
        <app-orderline-table *ngIf="hasOrders"
                             [orders]="orders"
                             [cartProducts]="cartProducts"
                             [currency]="currency"
                             (onAddCart)="addCart($event)">
        </app-orderline-table>

        <p class="no-orders" *ngIf="!hasOrders">
          {{ 'orders.no-orders' | translate }}
        </p>
      </ng-container>
      <app-products-loader
        [loading]="loading || expanding"
        [viewType]="viewType"
        [size]="'small'"
        [productsCount]="4">
      </app-products-loader>
    </div>
  </div>
</div>
